import { render } from "./help.svg?vue&type=template&id=55555c0c"
const script = {}
script.render = render

export default script